import dayjs from "dayjs";
import utcPlugin from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import { utcToLADateKey } from "../../utils/laDateUtils";

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

export const LA = "America/Los_Angeles";
export const DAYS = 12;

export const formatHeaderDay = (date) => dayjs(date).tz(LA).format("ddd");

export const formatHeaderDate = (date) => dayjs(date).tz(LA).format("DD-MMM-YYYY").toUpperCase();

export const getDates = (start, count) => {
  const base = dayjs(start).tz(LA);
  const dates = [];
  for (let i = 0; i < count; i++) {
    dates.push(base.add(i, "day").toDate());
  }
  return dates;
};

export const cellKey = (unitId, date) => `${unitId}|${utcToLADateKey(date)}`;

export const addOneDayKey = (dateKey) => {
  const [y, m, d] = dateKey.split("-").map(Number);
  const dt = new Date(y, m - 1, d + 1);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
};

export const groupBookingsByParticipant = (allBookings) => {
  const byParticipant = {};
  for (const b of allBookings) {
    const pid = b.participant_id?._id || b.participant_id;
    if (!byParticipant[pid]) byParticipant[pid] = [];
    byParticipant[pid].push(b);
  }
  const entries = [];
  for (const bks of Object.values(byParticipant)) {
    const sorted = [...bks].sort((a, b) => a.la_date_key.localeCompare(b.la_date_key));
    let run = [sorted[0]];
    for (let i = 1; i < sorted.length; i++) {
      if (sorted[i].la_date_key === addOneDayKey(run[run.length - 1].la_date_key)) {
        run.push(sorted[i]);
      } else {
        const from = run[0].la_date_key;
        const to = run[run.length - 1].la_date_key;
        entries.push({ participant: run[0].participant_id, dateLabel: from === to ? from : `${from} to ${to}`, bookings: run });
        run = [sorted[i]];
      }
    }
    const from = run[0].la_date_key;
    const to = run[run.length - 1].la_date_key;
    entries.push({ participant: run[0].participant_id, dateLabel: from === to ? from : `${from} to ${to}`, bookings: run });
  }
  return entries;
};
